import { SET_CURRENT_USER, SIGNUP, VERIFIED_OTP, RESEND_OTP, REVIEW_MEMBERSHIP } from './constants';
import { getPublicIP, getAuthHeader , setJWTToken, setUserInSession } from "../helpers/authHelper";
import { getReq , putReq, postReq} from './rest';
import { handleResponse , loader } from './utils';
export const loginUser = (user) => {
 
  if(user.req_status == true){

    if(user.membership_upgrade_status == "GOLD PENDING"){
      localStorage.setItem('modalstatus', JSON.stringify(user));
    }else if(user.membership_upgrade_status == "GOLD REJECTED"){
      localStorage.setItem('modalstatus', JSON.stringify(user));
      localStorage.setItem('rejectedstatus', JSON.stringify(user.membership_review));
    }else{
      localStorage.removeItem('modalstatus');
      localStorage.removeItem('rejectedstatus');
      setUserInSession(user);
      setJWTToken(user._authentication);
    }
    
  }
  return {
    type: SET_CURRENT_USER,
    user,
  };
};
export const createLoginRequest = (params) => {

  const bodyFormData = new FormData();
  bodyFormData.set('value', params.username);
  bodyFormData.set('password', params.password);
  //bodyFormData.set('device_token', getPublicIP());
  bodyFormData.set('device_token', params.fcm_token);
  bodyFormData.set('device_type', 'WEB');
  loader(true);
  const headers = getAuthHeader();
  return (dispatch, getState) => postReq(`${apiURLPrefix}/user/login`, bodyFormData , headers)
  .then(handleResponse)
  .then(res => 
    dispatch(loginUser(res))
  );
};


export const basicregistrationUser = (signupUser) => {
  return {
    type: SIGNUP,
    signupUser,
  };
};

export const basicRegistrationRequest = (params) => {

  const bodyFormData = new FormData();
  Object.keys(params).map(function(key, index) {
    bodyFormData.set(key, params[key]);
  });
  loader(true);
  const headers = getAuthHeader();
  return (dispatch, getState) => postReq(`${apiURLPrefix}/user/registration_basic`, bodyFormData , headers)
  .then(handleResponse)
  .then(res => 
     dispatch(basicregistrationUser(res))
  );
};

export const goldRegistrationRequest = (params) => {
 const bodyFormData = new FormData();
  Object.keys(params).map(function(key, index) {
    bodyFormData.set(key, params[key]);
  });
  loader(true);
  const headers = getAuthHeader();
  return (dispatch, getState) => postReq(`${apiURLPrefix}/user/registration`, bodyFormData , headers)
  .then(handleResponse)
  .then(res => 
     dispatch(basicregistrationUser(res))
  );
};


export const verifiedOtp = (verifyOtp) => {
  // if(verifyOtp.req_status == true){
  //   setUserInSession(verifyOtp);
  //   setJWTToken(verifyOtp._authentication);
  // }
  return {
    type: VERIFIED_OTP,
    verifyOtp,
  };
};
export const otoVerification = (params = null) => {
 
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    Object.keys(params).map(function(key, index) {
      bodyFormData.set(key, params[key]);
    });
    loader(true);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/user/otp_validation`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      dispatch(verifiedOtp(res));
      if(params.membership == 'BASIC'){
        dispatch(loginUser(res));
      }else if((params.membership == 'GOLD') && (res.req_status == true)){
        localStorage.setItem('modalstatus', JSON.stringify(res));
      }
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};

export const resendOtp = (resendOtp) => {
 
  return {
    type: RESEND_OTP,
    resendOtp,
  };
};
export const resendotpRequest = (params = null) => {
 
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    Object.keys(params).map(function(key, index) {
      bodyFormData.set(key, params[key]);
    });
    loader(true);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/user/resend_otp`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      dispatch(resendOtp(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};


export const resendemailotpRequest = (params = null) => {
 
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    Object.keys(params).map(function(key, index) {
      bodyFormData.set(key, params[key]);
    });
    loader(true);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/user/resend_otp_for_email_verification`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      dispatch(resendOtp(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};


export const reviewMembership = (reviewMembership) => {
  localStorage.removeItem('rejectedstatus');
  return {
    type: REVIEW_MEMBERSHIP,
    reviewMembership,
  };
};
export const reviewmembershipRequest = (params = null) => {
 
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    Object.keys(params).map(function(key, index) {
      bodyFormData.set(key, params[key]);
    });
    loader(true);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/user/update_membership_review`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      dispatch(reviewMembership(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};


export const loginMembership = (user) => {
  return {
    type: SET_CURRENT_USER,
    user,
  };
};

export const changeUserMembership = (params) => {
  return (dispatch,getState) => {
      dispatch(loginMembership(params));
  }
};